// extracted by mini-css-extract-plugin
export default {"root":"Feedback_root__1E610","title":"Feedback_title__CeSKI"};